import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from "../../environments/environment";
import { LoaderService } from "./loader.service";
import { ApiConfig } from "../config/api.config";
import { RequestOptionsInterface } from "../models/request.options.interface";
import { AppHelper } from "../helpers/app.helper";

import { FileService } from "./file.service";

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  onNuevoRequest = new EventEmitter<{ path: string, url: string }>();

  onBeginRequest = new EventEmitter();

  onEndRequest = new EventEmitter();

  onEndSession = new EventEmitter();

  token: string;

  static get host(): string {

    return environment.apiUrl;
  }

  constructor(private router: Router, private http: HttpClient,
    private loaderService: LoaderService) {
  }

  /**
   * Check if exists a param into url string. The params is recognized because is enclosed by '{}'
   */
  protected static checkMissingParamOnUrl(url: string): boolean {

    if (!url) {
      return true;
    }

    const indexOpen = url.indexOf('{');
    if (indexOpen < 0) {
      return true;
    }

    const indexClose = url.indexOf('}');
    let param: string;
    if (indexClose < 0) {
      param = 'undefined';
    } else {
      param = url.slice(url.indexOf('{') + 1, url.indexOf('}'));
    }

    throw new Error(`Missing ${param} on route.Check ${url}`);
  }

  /**
   * Create a url from  a named route, url and query params
   */
  public getUrl(routeName: string, params?: any, query?: string): string {

    let url = ApiConfig.routes[routeName];

    if (!url) {
      throw new Error(`Missing ${routeName} on route. container. Check your ApiConfig.`);
    }

    if (params) {
      Object.keys(params).forEach((k) => {
        url = url.replace(`{${k}}`, params[k]);
      });
    }

    RequestService.checkMissingParamOnUrl(url);
    return `${RequestService.host}/${url}${query ? `?${query}` : ''}`;
  }

  get(path, options?: any): Promise<any | any[]> {

    return this.request(path, 'GET', options);
  }

  post(path, options?: any): Promise<any | any[]> {

    return this.request(path, 'POST', options);
  }

  postFile(path, options?: any){

    return this.uploadsFile(path,options);

  }

  getFile(path, options?: any){

    return this.downloadsFile(path,options);

  }

  private downloadsFile(path,  options?: any ){

    const params = options.params ? options.params : {};
    const url = this.getUrl(path, params, options.query ? options.query : '');

      const header = {};
        header['Authorization'] = `Bearer ${this.token}`;
        header['responseType'] = 'text';

       const headers = new HttpHeaders(header);


    this.onBeginRequest.emit();

    return this.http.get(url, { headers, responseType: 'text' });
 
  }

  private uploadsFile(path,  options?: any ){

    const params = options.params ? options.params : {};
    const url = this.getUrl(path, params, options.query ? options.query : '');

    const response: any = {};

      const header = {};
        header['Authorization'] = `Bearer ${this.token}`;

       const headers = new HttpHeaders(header);


    this.onBeginRequest.emit();

    return  this.http.post(url, options.formData, headers ? { headers } : undefined);

    //this.onNuevoRequest.emit({ path, url })
    //this.onEndRequest.emit();

  }

  put(path, options?: any): Promise<any | any[]> {

    return this.request(path, 'PUT', options);
  }

  delete(path, options?: any): Promise<any | any[]> {

    return this.request(path, 'DELETE', options);
  }

  private async request(path, method = 'GET', options: RequestOptionsInterface) {

    const params = options.params ? options.params : {};
    const url = this.getUrl(path, params, options.query ? options.query : '');
    let headers: any;

    headers = await this.createHeaders(options.ignoreToken, options.multipart);

    const loading = !options.hideLoading;
    if (loading) {

      this.loaderService.show();
    }

    if (!environment.production && options.log) {

      console.group('RequestService');
      console.log(`URL: ${url}`);
      console.log(`METHOD: ${method}`);
      console.log('params: ', params);
    }

    try {

      this.onBeginRequest.emit();

      const response = await this.callDefault(url, method, options.formData ? options.formData : params,
        headers, options.blob).toPromise()
        .finally(() => loading ? this.loaderService.hide() : '');

      this.onNuevoRequest.emit({ path, url })
      this.onEndRequest.emit();

      if (!environment.production && options.log) {

        console.log('response: ', response);
        console.groupEnd();
      }

      return response;
    } catch (e) {

      if (!environment.production && options.log) {

        console.log('response: ', e);
        console.groupEnd();
      } else {

        console.log(e);
      }

      this.onEndRequest.emit();

      if (e?.error?.code == '401' && path !== 'login') {

        this.onEndSession.emit();
      }

      throw new Error(e?.error?.code == '401' ? 'Acceso denegado. Revise sus credenciales de acceso.' : e?.error?.detail || e.message);
    }
  }

  async createHeaders(ignoreToken, multipart = false) {

    try {

      const headers = {};
      if (!ignoreToken) {

        if (!this.token) {
          return;
        }

        headers['Authorization'] = `Bearer ${this.token}`;
      }

      if (!multipart) {

        headers['Content-Type'] = 'application/json';

      } else {
        headers['Content-Type'] = 'application/json';
        headers['Content-Type'] = 'multipart/form-data;';
        headers['enctype'] = 'multipart/form-data';

      }

      return new HttpHeaders(headers);

    } catch (e) {

      AppHelper.DevPrint(e);
    }

  }

  callDefault(url, method, params, headers?: HttpHeaders, blob = false) {

    switch (method) {
      case 'GET':

        const options = headers ? { headers } : {};

        if (blob) {

          options['responseType'] = 'blob';
        }

        return this.http.get(url, options);
      case 'POST':
        return this.http.post(url, params, headers ? { headers } : undefined);
      case 'POSTFILE':
        return this.http.post(url, params, headers ? { headers } : undefined);
      case 'PUT':
        return this.http.put(url, params, headers ? { headers } : undefined);
      case 'DELETE':
        return this.http.delete(url, headers ? { headers } : undefined);
    }
  }

}
